const Candidate = () => import('../views/candidate.vue')

export default [
  {
    path: '/page/candidate',
    component: Candidate,
    meta: { requiresAuth: true },
    name: 'page.candidate'
  }
]